// extracted by mini-css-extract-plugin
export var heroContainer = "home-module--heroContainer--U-hCS";
export var comercianteTxt = "home-module--comercianteTxt--3_RpY";
export var comercianteImg = "home-module--comercianteImg--2mvz8";
export var desenvolvedorTxt = "home-module--desenvolvedorTxt--2WUYm";
export var desenvolvedorImg = "home-module--desenvolvedorImg--2_nR0";